import { Button, Modal } from "@thetreep/ui";
import { useTranslation } from "react-i18next";
import ReactPlayer from "react-player";
import { useModal } from "@hooks/useModal";

const HELP_VIDEO_URL =
  "https://storage.googleapis.com/tsam-frontend-assets/Assurance%20maladie.mp4";

export function HelpVideo() {
  const { t } = useTranslation();
  const { isOpen, openModal, closeModal } = useModal();

  return (
    <div className="flex flex-col items-center gap-4 rounded-lg bg-light-blue-200 px-6 py-8 text-center text-text-strong">
      <h3 className="font-jakarta font-bold text-blue-medium text-[20px] md:text-[24px]">
        {t("home.helpVideoTitle")}
      </h3>
      <p className="text-[14px] md:text-[16px]">
        {t("home.helpVideoDescription")}
      </p>
      <button
        type="button"
        onClick={openModal}
        className="cursor-pointer underline font-bold text-blue-medium"
      >
        {t("home.helpVideoLink")}
      </button>

      <Modal size="large" isOpen={isOpen} onClose={closeModal}>
        <div className="flex flex-col gap-4">
          <h2 className="text-text-strong text-[20px] font-jakarta font-bold">
            {t("home.helpVideoTitle")}
          </h2>
          {isOpen && (
            <ReactPlayer
              src={HELP_VIDEO_URL}
              controls
              playing
              width="100%"
              height="auto"
              style={{ aspectRatio: "16 / 9" }}
            />
          )}
          <Button size="compact" alignself="end" onClick={closeModal}>
            {t("modal.close")}
          </Button>
        </div>
      </Modal>
    </div>
  );
}
